export const ApplicationConstant = {
    ApplicationID : 40,
    clientId : 29,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
